{
  "date": "{{day}} {{month}}, {{year}}",
  "docs": {
    "cpa": "l'Autorisation relative au profil de crédit",
    "esign": "Consentement à la signature électronique",
    "pp": "la Politique de confidentialité",
    "tos": "les Conditions d'utilisation",
    "uplift": {
      "lendersLink": "https://uplift.com/lenders",
      "footnotes": "<div><span>En cliquant sur \"Commençons\", j'accepte le </span><esignLink /><span>, </span><cpaLink /><span>, </span><ppLink /><span> et </span><tosLink /><span>.</span></div>",
      "please-ensure": "<div><span>Veuillez vous assurer que les renseignements que vous avez fournis sont bien les vôtres. Ils serviront à vérifier votre identité auprès de tiers. Votre taux d'intérêt dépend de votre pointage de crédit, du montant et de la durée du prêt, de l'utilisation de votre crédit et de vos antécédents de crédit. Tous les prêts sont consentis par Services UpLift Canada, SARI. Pour plus d'infos, voir les <tosLink /> et la <ppLink />.</span></div>"
    },
    "flexpay": {
      "lendersLink": "https://upgrade.com/flex-pay/lenders",
      "footnotes": "<div><span>En cliquant sur \"Commençons\", j'accepte le </span><esignLink /><span>, </span><cpaLink /><span>, </span><ppLink /><span> et </span><tosLink /><span>. J'autorise également Upgrade et ses filiales à obtenir mon dossier de crédit à la consommation afin de me présenter des offres de prêt potentielles.</span></div>",
      "please-ensure": "<div><span>Veuillez vous assurer que les informations fournies sont complètes et exactes. Elles seront utilisées pour vérifier votre identité. Votre taux dépend de votre pointage de crédit, du montant et de la durée du prêt, de l'utilisation du crédit et de vos antécédents de crédit. Les prêts accordés via Flex Pay par Upgrade sont offerts par ces partenaires prêteurs :</span> <lendersLink>upgrade.com/flex-pay/lenders</lendersLink><span>.</span></div>"
    }
  },
  "read-only-labels": {
    "name": "Demandeur",
    "phone-number": "Numéro du téléphone cellulaire",
    "email": "Courriel",
    "trip-dates": "Dates de voyage",
    "trip-date": "Date du voyage",
    "purchase-cost": "Coût de l'achat"
  },
  "subvention-promo": "Un TAP aussi bas que 0 % peut être disponible",
  "estimated-payment": {
    "header": "Paiement estimé",
    "from-payment": "à partir de <payment /> /mois",
    "apr": "<span>Calcul estimé sur la base d'un TAP de <apr />, et d’un premier versement aujourd'hui à partir de <downpayment />, suivi de <numberofpayments>{{numberOfPayments}}</numberofpayments> versements sur le prêt.</span>"
  },
  "required-fields": "Tous les champs sont requis",
  "regular-application": {
    "inputs": {
      "first_name": {
        "label": "Prénom",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "requise*"],
          ["minLength2", "requise*"],
          ["validName", "non valide*"]
        ]
      },
      "last_name": {
        "label": "Nom de famille",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "requise*"],
          ["minLength2", "requise*"],
          ["validName", "non valide*"]
        ]
      },
      "address": {
        "label": "Adresse du domicile*",
        "isRequired": true,
        "validity": [
          ["required", "Adresse du domicile requise*", "ignore label"],
          ["minLength2", "Adresse du domicile non valide*", "ignore label"],
          ["notEmail", "Adresse du domicile non valide*", "ignore label"],
          ["notPOBox", "Boîte postale non acceptée*", "ignore label"]
        ]
      },
      "city": {
        "label": "Ville*",
        "isRequired": true,
        "validity": [
          ["required", "Ville requise*", "ignore label"],
          ["minLength2", "Ville non valide*", "ignore label"],
          ["notEmail", "Ville non valide*", "ignore label"]
        ]
      },
      "region": {
        "label": "Province*",
        "isRequired": true,
        "placeholder": "Choisir le province",
        "validity": [
          ["required", "Province requise*", "ignore label"],
          ["minLength2", "Province non valide*", "ignore label"],
          ["validRegionCA", "Province non valide*", "ignore label"]
        ]
      },
      "postal_code": {
        "label": "Code postal*",
        "isRequired": true,
        "mask": "A0A 0A0",
        "placeholder": "55555",
        "validity": [
          ["required", "Code postal requise*", "ignore label"],
          ["minLength5", "Code postal non valide*", "ignore label"]
        ],
        "postProcess": "digitCharOnlyString"
      },
      "date_of_birth": {
        "label": "Date de naissance",
        "isRequired": true,
        "showRequiredIcon": true,
        "mask": "00/00/0000",
        "maxLength": "10",
        "format": "ddmmyyyy",
        "placeholder": "jj/mm/aaaa",
        "srOnly": "D D M M Y Y Y Y",
        "tooltip": "<span>Le demandeur doit être âgé de 19 ans ou plus.</span>",
        "validity": [
          ["required", "requise*"],
          ["minLength8", "non valide*"],
          ["validDate", "non valide*"],
          [
            "isNotUnderageCA",
            "Doit être âgé de 19 ans ou plus*",
            "ignore label"
          ],
          ["validBirthdate", "non valide*"]
        ],
        "postProcess": "reformatDateOfBirthCA"
      },
      "income": {
        "label": "Revenu annuel brut",
        "maxLength": "10",
        "isRequired": true,
        "showRequiredIcon": true,
        "placeholder": "50 000 $",
        "postProcess": "priceInCents",
        "symbol": "$",
        "validity": [["validAmount", "requise*"]],
        "tooltip": "<div><span>Comprend le revenu annuel de votre ménage avant impôts, arrondi au dollar près.</span></div>"
      },
      "email": {
        "label": "courriel",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "requise*"],
          ["validEmail", "non valide*"]
        ]
      },
      "mobile": {
        "label": "Numéro du téléphone cellulaire",
        "isRequired": true,
        "showRequiredIcon": true,
        "tooltip": "<span>Nous en avons besoin pour</span><br><span>vous envoyer un code de.</span>",
        "mask": "000-000-0000",
        "placeholder": "555-555-5555",
        "validity": [
          ["required", "requise*"],
          ["requiredLength10", "non valide*"]
        ]
      },
      "monthly_housing_cost": {
        "label": "Coûts mensuels de logement",
        "maxLength": "10",
        "isRequired": true,
        "showRequiredIcon": true,
        "placeholder": "5 000 $",
        "symbol": "$",
        "postProcess": "priceInCents",
        "validity": [["required", "requise*"]]
      },
      "primary_income_source": {
        "label": "Principale source de revenus",
        "isRequired": true,
        "showRequiredIcon": true,
        "placeholder": "Choisir une option",
        "validity": [["required", "requise*"]]
      },
      "occupation": {
        "label": "Profession",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [["required", "requise*"]]
      },
      "employment_duration": {
        "label": "Durée avec l’employeur actuel",
        "placeholder": "Choisir une option",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [["required", "requise*"]]
      }
    },
    "header": "<h2>Prêt(e) à vérifier votre taux ?</h2>",
    "header-with-name": "<h2>Bonjour {{name}}, prêt(e) à vérifier votre taux ?</h2>",
    "subheader": {
      "verify-details": "Veuillez vous assurer que les informations ci-dessous sont exactes.",
      "no-inquiry": "Le vérification de votre admissibilité n'affectera pas votre pointage de crédit.",
      "learn-more": "En savoir plus"
    }
  },
  "incomeSources": {
    "salaried": "Salarié",
    "self-employed": "Travailleur indépendant",
    "investments": "Investissements",
    "other": "Autre"
  },
  "employmentDurations": {
    "<1": "Moins d’un an",
    "1-2": "De 1 à 2 ans",
    "3-5": "De 3 à 5 ans",
    ">5": "Plus de 5 ans"
  },
  "uplift": {
    "marketing-communication-opt-in": "Oui, j'aimerais recevoir des informations sur les nouvelles offres et aubaines d'Uplift."
  },
  "flexpay": {
    "marketing-communication-opt-in": "Oui, je voudrais recevoir des informations sur les nouvelles offres de Flex Pay."
  },
  "submit": "Commençons"
}
